export default {"src":"/_next/static/media/repeat.374aa6fc.svg","height":24,"width":24};